import React, { useEffect, useState } from 'react';
import OneToTenAnimation from '../../../PowerFullAnimation/OneToTenAnimation';
import LiveCourse from '../../HomePages/LiveCourse/LiveCourse';
import OneToTenCourseCart from './OneToTenCourseCart';
import PopularCourseCartAimation from '../../../PowerFullAnimation/PopularCourseCartAimation';

const OneToTenCourse = () => {
    const [course, setCourse] = useState([]);
    const [loadding, setLoadding] = useState(true);

    //load course api
    useEffect(() => {
        fetch('https://one0m-backend2.onrender.com/oneToTen')
            .then(res => res.json())
            .then(result => {
                setCourse(result?.getLesson)
                setLoadding(false);
            })
            .catch(err => {
                setLoadding(true);
            })
    }, [course])



    return (
        <div>
            <div className="course-title">
                <h4 className='fw-bold mb-3 fs-3'>ফ্রি রেকর্ডেড কোর্সসমূহ</h4>

                <div className="row gy-3">
                    {
                        course?.map(tenCourse => <OneToTenCourseCart tenCourse={tenCourse} key={tenCourse?._id} />)
                    }
                </div>
                <div className="setLoading">
                    {
                        loadding ? <>
                            <PopularCourseCartAimation />
                            <div className="kasla mt-3"></div>
                            <PopularCourseCartAimation />
                            <div className="ksala mt-3"></div>
                            <PopularCourseCartAimation />
                        </>
                            : ""

                    }
                </div>
            </div>
            {/* =====================Paid course Import=========================== */}
            <LiveCourse />
        </div>
    );
};

export default OneToTenCourse;